var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.prospectuses.length !== 0
    ? _c("div", { staticClass: "row prospectus-list" }, [
        _c("div", { staticClass: "col-sm-12 table-responsive" }, [
          _c("h2", [_vm._v(_vm._s(_vm.conf.translations.searchresults))]),
          _vm._v(" "),
          _c(
            "table",
            {
              staticClass: "table",
              attrs: { id: "prospectus-table", "aria-live": "polite" }
            },
            [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.conf.translations.corporation))]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(_vm._s(_vm.conf.translations.approvalDate))
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(_vm._s(_vm.conf.translations.typeOfProspectus))
                  ]),
                  _vm._v(" "),
                  _vm.lastSearchParams.ProspectusType === 4
                    ? _c("th", [
                        _vm._v(_vm._s(_vm.conf.translations.notificationDate))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.lastSearchParams.ProspectusType === null
                    ? _c("th", [
                        _vm._v(
                          _vm._s(_vm.conf.translations.nationalIdentifier) +
                            "/" +
                            _vm._s(_vm.conf.translations.notificationDate)
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.lastSearchParams.ProspectusType !== 4 &&
                  _vm.lastSearchParams.ProspectusType !== null
                    ? _c("th", [
                        _vm._v(_vm._s(_vm.conf.translations.nationalIdentifier))
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.prospectuses, function(item, index) {
                return _c("prospectus-item", {
                  key: index,
                  attrs: { prospectus: item }
                })
              })
            ],
            2
          )
        ])
      ])
    : _vm.lastSearchParams !== null
    ? _c("div", { staticClass: "row prospectus-list-no-data" }, [
        _c(
          "div",
          {
            staticClass: "col-12-sm",
            attrs: { id: "prospectus-no-results", role: "alert" }
          },
          [_vm._v(_vm._s(_vm.conf.translations.noresults))]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b52a204", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b52a204","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/js/Prospectus3Page/src/ProspectusList.vue
// module id = 302
// module chunks = 1